import { css } from '@emotion/css'
import { spacing, breakpoint, shorthandHelper, mediaQueryHelper } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    boxSizing: 'border-box',
    margin: 'auto',
    padding: shorthandHelper([0, spacing.default]),
    width: '100%',

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: shorthandHelper([0, spacing.medium]),
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      width: breakpoint.desktop,
    },
  }),
}

export default styles
